import { Outlet, useLocation } from "react-router-dom";

import { ThemeSwitch } from "@/client/components/theme-switch";
import { FormFocusProvider, useFormFocus } from "@/client/contexts/form-focus-context";

import { Footer } from "./components/footer";
import { Header } from "./components/header";

const HomeLayoutContent = () => {
  const { isFormFocused } = useFormFocus();
  const location = useLocation();

  const isAiGeneratorPage = location.pathname.includes("/ai-generator");

  // Use body/document scrolling for proper header scroll detection
  return (
    <div className="min-h-screen bg-transparent">
      {!isFormFocused && <Header />}
      <Outlet />
      {!isFormFocused && !isAiGeneratorPage && <Footer />}
      {!isFormFocused && isAiGeneratorPage && (
        <footer className="flex justify-center border-t border-border/60 bg-background/90 py-3 backdrop-blur-md">
          <ThemeSwitch />
        </footer>
      )}
    </div>
  );
};

export const HomeLayout = () => (
  <FormFocusProvider>
    <HomeLayoutContent />
  </FormFocusProvider>
);
